

<div class="content">
    <header>
        <div class="left">
            <button mat-button routerLink="/"><mat-icon>arrow_back</mat-icon> Dashboard</button>
        </div>

        <div class="right">
            <button color="primary" (click)="openCategoriesDialog()" mat-raised-button>Categories</button>
        </div>
    </header>

    <!-- <div class="search-bar">
        <mat-form-field class="search" appearance="outline">
            <input (focus)="searchHasFocus()" matInput [(ngModel)]="searchQuery" placeholder="Search" (keyup)="searchChange($event)">
        </mat-form-field>
    </div> -->
    

    <div class="tabs">
        <div class="left">
            <button [class.active]="activeTab=='recent'" (click)="activateTab('recent')" mat-button>Recently Added</button>
            <button [class.active]="activeTab=='categories'" (click)="activateTab('categories')" mat-button>Categories</button>
            <button [class.active]="activeTab=='search'" (click)="activateTab('search')" mat-button>Search</button>
        </div>
    
        <div class="center">
    
        </div>
    
        <div class="date-range-colume">
    
        </div>
    </div>



    <!-- <div  *ngIf="isSearching" class="cancel-search-button">
        <button (click)="cancelSearch()" mat-raised-button>Cancel Search</button>
    </div> -->

    <ng-container *ngIf="activeTab == 'recent'">
        <div class="stats">
            <div>
                Viewing
                <p>{{items.length}}</p>
            </div>
            <div class="unlistedLabel" (click)="showUnlistedOnly()">
                Unlisted
                <p>{{notListedCount}}</p>
            </div>
            <div class="search">
                <ap-search alignRight="true" (onChange)="filter($event)" (cancelled)="filterCancelled()"></ap-search>
            </div>
        </div>

        <table class="inventory" mat-table [dataSource]="dataSource" multiTemplateDataRows>

            <!-- Column Headers -->
            <ng-container matColumnDef="image">
                <td class="image-column" mat-cell *matCellDef="let item">
                    <div (click)="viewItem(item)" [style]="getPlaceholder()" class="placeholder">
                        <div [style]="getImage(item)" class="placeholder2"></div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <td class="code-column" mat-cell *matCellDef="let item">
                    <div class="code">
                        <span matTooltip="Needs improvement" *ngIf="item.status == 'Needs Improvement'">⚠️</span>
                        <span matTooltip="Pending Review" *ngIf="item.status == 'Pending Review'">☑️</span>
                        <span class="pound">#</span>{{item.number}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <td class="title" mat-cell *matCellDef="let item; let i = dataIndex;" (click)="viewItem(item, i)">
                    <div class="title-text">
                        <span class="code desktop-hide"><span class="pound">#</span>{{item.number}}</span>
                        {{getTitle(item.title)}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <td mat-cell *matCellDef="let item">
                    {{item.decision}}
                </td>
            </ng-container>

            <ng-container matColumnDef="salesChannels">
                <td class="salesChannels" mat-cell *matCellDef="let item">
                    <div class="channel-links">
                    <ng-container *ngIf="item.status == 'Sold'">
                        SOLD
                    </ng-container>
                    <ng-container *ngIf="item.status != 'Sold'">
                        <a *ngIf="item.webflow && item.webflow.isListed" target="_blank"><span><img height="20" src="assets/icons/webflow.png"></span></a>
                        <a *ngIf="item.facebook && item.facebook.url != ''" target="_blank" [href]="item.facebook.url"><span><img height="20" src="assets/icons/facebook.png"></span></a>
                        <a *ngIf="item.ebay && item.ebay.ItemID != 0" target="_blank" [href]="'https://ebay.com/itm/' + item.ebay.ItemID"><span><img height="20" src="assets/icons/ebay.png"></span></a>
                    </ng-container>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="dateListed">
                <th class="amount" mat-header-cell *matHeaderCellDef>Last Modified</th>
                <td class="amount" mat-cell *matCellDef="let item">
                    {{item.lastModified | timeago}}
                </td>
            </ng-container>

            <tr class="inventory-row"
                [class.sold]="item.status=='Sold'"
                apStatus="View item"
                mat-row
                *matRowDef="let item; let i = dataIndex; columns: columnsToDisplay;">
            </tr>
        </table>
    </ng-container>

    <ng-container *ngIf="activeTab == 'categories'">
        <app-inventory-categories-component></app-inventory-categories-component>
    </ng-container>

    <ng-container *ngIf="activeTab == 'search'">
        <ap-search (onChange)="search($event)" [apStatus]="" type="number"></ap-search>

        <ng-container *ngIf="searchItem != null">
            <div>{{searchItem.title}}</div>
            <div (click)="viewItem(searchItem)" class="searchImage" [style]="getImage(searchItem, 600)"></div>
            {{searchItem.stockTake | date:'dd-MM-yy'}}
        </ng-container>
    
        <div *ngIf="searchItem != null">
            <!-- <button (click)="tick()" mat-button>Tick</button> -->
            <button (click)="checkout(searchItem)" mat-button>Checkout</button>
        </div>
    </ng-container>
</div>
